const siteConfig = {
  brandName: "ottireluna",
  logo: {
    text: "ottireluna",
    ariaLabel: "ottireluna home",
  },
  description:
    "Thoughtful home accessories selected for calm, colourful and practical everyday living.",
  tagline: "Small objects, warmer homes.",
  location: "Hong Kong",
  currency: {
    code: "USD",
    symbol: "$",
    locale: "en-US",
  },
  shipping: {
    freeThreshold: Number.POSITIVE_INFINITY,
    standardRate: 9.99,
    dispatchDays: "1–2 business days",
  },
  contact: {
    email: "mail@ottireluna.site",
    address: "Hong Kong",
    hours: "Monday–Friday, 9:00–17:00 HKT",
  },
  social: {},
  announcement: "TRACKED DELIVERY $9.99 — VIEW DETAILS",
};

export const formatPrice = (value) =>
  new Intl.NumberFormat(siteConfig.currency.locale, {
    style: "currency",
    currency: siteConfig.currency.code,
  }).format(Number(value));

export default siteConfig;
